import { useQuery } from '@tanstack/react-query';

import { getOrganization, type IActor } from '../../entities/organization';
import { useSession } from '../../entities/session';

export const useOrganizationSettings = () => {
  const session = useSession();
  const organization = useQuery({ queryKey: ['organization'], queryFn: getOrganization });

  const membership = session.data?.memberships.find((entry) => entry.isCurrent);
  const actor: IActor | null =
    session.data && membership ? { userId: session.data.user.id, role: membership.role } : null;

  return { session, organization, actor, timeZone: session.data?.preferences.timezone };
};
